import CommissionsByRider from './CommissionsByRider';

export default CommissionsByRider;
